import React from 'react';
type StatusType = 'abaixo' | 'dentro' | 'acima';
interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  const styles = {
    abaixo: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    dentro: 'bg-amber-100 text-amber-800 border-amber-200',
    acima: 'bg-red-100 text-red-800 border-red-200'
  };
  const labels = {
    abaixo: 'Abaixo da Média',
    dentro: 'Dentro da Média',
    acima: 'Acima da Média'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[status]} ${className}`} data-id="element-310">
      {labels[status]}
    </span>;
}